import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
const Breadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const PARENT_MAP = {
    "/nyafaz-brand/add-product": "/nyafaz-brand/productlist",
    "/nyafaz-brand/edit-product": "/nyafaz-brand/productlist",
    "/nyafaz-brand/view-product": "/nyafaz-brand/productlist",
    "/nyafaz-brand/product/": "/nyafaz-brand/productlist",
    "/nyafaz-brand/add-plan": "/nyafaz-brand/users",
    "/nyafaz-brand/subscriptions/": "/nyafaz-brand/subscriptions",
    "/nyafaz-brand/invoice/": "/nyafaz-brand/invoices",
    "/nyafaz-brand/payments/": "/nyafaz-brand/payment-requests",
    "/nyafaz-brand/add-service": "/nyafaz-brand/servicelist",
    "/nyafaz-brand/edit-service": "/nyafaz-brand/servicelist",
    "/nyafaz-brand/view-service": "/nyafaz-brand/servicelist",
    "/nyafaz-brand/service/": "/nyafaz-brand/servicelist",
  };

  const LABELS_MAP = {
    "dashboard": "Dashboard",
    "ib-dashboard": "Dashboard",
    "productlist": "Product list",
    "add-product": "Add Product",
    "edit-product": "Edit Product",
    "view-product": "View Product",
    "users": "Users",
    "add-plan": "Add Plan",
    "organization": "Organizations",
    "edit-profile": "Edit Profile",
    "settings": "Settings",
    "invoices": "Invoices",
    "subscriptions": "Subscriptions",
    "payment-requests": "Payments",
    "invoice": "Invoice details",
    "payments": "Payment details",
  };

  const getLabel = (segment) => {
    if (LABELS_MAP[segment]) return LABELS_MAP[segment];
    return segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // Find the parent route entry
  const parentEntry = Object.entries(PARENT_MAP).find(([key]) => path.startsWith(key));

  // If current path is NOT a sub-page (not in PARENT_MAP), hide the breadcrumb entirely
  if (!parentEntry) return null;

  const parentPath = location.state?.from || parentEntry[1];
  const parentLabel = getLabel(parentPath.split("/").pop());
  const currentSegment = path.split("/").filter(Boolean).pop();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => navigate(parentPath)}
        className="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-all"
        title={`Back to ${parentLabel}`}
      >
        <IoArrowBack size={20} />
      </button>

      <span className="text-gray-300">|</span>

      <span className="font-semibold text-gray-800 text-sm">
        {getLabel(currentSegment)}
      </span>
    </div>
  );
};

export default Breadcrumb;
